import React, { useState, useContext, useEffect } from 'react';
import { Button, Col, Form, Input, Modal, Row, Select, Card } from 'antd';
import Colors from "../../../styles/Colors";
import { BiCheck, BiX } from "react-icons/bi";
import { defaultUser, User } from "../../../model/root/User";
import { AuthContext } from "../../../config/AuthContext";
import { Rol } from '../../../model/root/Rol';
import { GetHoraris } from "../../../dao/root/GetHoraris";
import {GetUsuaris} from "../../../dao/root/GetUsuaris";
import { Escola } from '../../../model/root/Escola';
import { PostUsuarisDuplicar } from '../../../dao/admin/PostUsuarisDuplicar';
import { GetUsuariIdPerfil } from "../../../dao/root/GetUsuariIdPerfil";
import dayjs from "dayjs";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';

const { Option } = Select;

interface DuplicarModalProps {
    element: User;
    visible: boolean;
    onClose: (value: boolean) => void;
}

const DuplicarModal: React.FC<DuplicarModalProps> = ({ element, visible, onClose }) => {
    const [form] = Form.useForm();
    const { isLoggedIn, userId, user, page } = useContext(AuthContext);
    const [coleccioR, setDadesR] = useState<Rol[]>([]);
    const [coleccioE, setDadesE] = useState<Escola[]>([])
    const [horaris, setHoraris] = useState<any[]>([]);
    const [usuari, setUsuari] =  useState<any>({});
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    

    useEffect(() => {
        checkDades();

    }, [element]);

    async function checkDades() {
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
        const dades = await GetUsuariIdPerfil(element.id+'', element.empresa);
        setUsuari(dades && dades.length > 0 ? transformarDades(dades[0]) : {});

    }
    function transformarDades(original: any) {
        const naixFills = original.naix
            ?.replace(/^\[|\]$/g, '') // quitamos los corchetes
            .split(', ')
            .map((dateStr: any) => {
                const cleaned = dateStr.replace(/CEST|CET|GMT\+\d+|UTC/g, '').trim();
                const dateObj = new Date(cleaned);
                return isNaN(dateObj.getTime()) ? null : dayjs(dateObj);
            })
            .filter((date: any): date is dayjs.Dayjs => date !== null) || [];

        const disciplines = original.disciplines
            ?.replace(/^\[|\]$/g, '')
            .split(', ')
            .map((d: any) => d.trim()) || [];

        const naix =
            naixFills.length > 0
                ? naixFills.map((date: dayjs.Dayjs) => date.year()).join(', ')
                : null;

        return {
            ...original,
            naix: naix, // será string con años separados por coma o null
            grauDiscapacitatDetall: original.discapacitat,
            convivencia: original.convivencia, // mantenemos como número
            disciplines: disciplines.join(', '), // aseguramos string
            naixFills: naixFills // array de dayjs o vacío
        };
    }

    const handleEmpresaChange = async (empresa: string) => {
        form.setFieldValue("empresa", empresa);
        // Cargar roles y escuelas
        const dades = await GetUsuaris(empresa);
        setDadesR(dades?.rols || []);
        setDadesE(dades?.escoles || []);

        // Cargar horarios
        const horarisData = await GetHoraris(empresa);
        setHoraris(horarisData || []);
    };
    const handleSubmit = async () => {
        
        const empresaSeleccionada = form.getFieldValue('empresa');
        const rolsSeleccionats = form.getFieldValue('rol') || [];
        const horarisSeleccionats = form.getFieldValue('horaris') || [];
        const escolesSeleccionats = form.getFieldValue('escoles') || [];

        const usuariModificat = {
        ...usuari,
        rol: rolsSeleccionats.map((id: number) => ({ id: id })),
        horaris: horarisSeleccionats.map((id: number) => ({ id: id })),
        escoles: escolesSeleccionats.map((id: number) => ({ id: id }))
        };
        
        await PostUsuarisDuplicar(empresaSeleccionada, usuariModificat);
        onClose(true);
    };


    const handleCancel = () => {
        onClose(false);
    };

    return (
        <Modal
            title="Duplicar Usuari"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={'40%'}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                       <Form.Item 
                            label={
                                <span>
                                    Escull l'empresa on vols duplicar l'usuari <strong>{element.nom}</strong>
                                </span>
                            }
                            name="empresa" 
                            rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                        >
                            <Select
                                placeholder="Selecciona una empresa"
                                onChange={handleEmpresaChange}
                            >
                                {Array.isArray(empresas) && empresas.map(value =>
                                    <Option key={value.id} value={value.datasource}>
                                        {value.nomEmpresa}
                                    </Option>
                                )}
                            </Select>
                                                                   
                            </Form.Item>
                    </Col>
                    {form.getFieldValue("empresa") && (
                        <>
                            <Col span={24}>
                                <Form.Item label="Assignar rol(s)" name="rol">
                                    <Select mode="multiple" placeholder="Selecciona rols">
                                        {coleccioR.map((rol) => (
                                            <Option key={rol.id} value={rol.id}>
                                                {rol.nom}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Assignar horari(s)" name="horaris">
                                    <Select mode="multiple" placeholder="Selecciona horaris">
                                        {horaris.map((horari) => (
                                            <Option key={horari.id} value={horari.id}>
                                                {horari.nom || horari.titol}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item label="Assignar permisos d'escoles" name="escoles">
                                    <Select mode="multiple" placeholder="Selecciona escola">
                                        {coleccioE.map((escola) => (
                                            <Option key={escola.id} value={escola.id}>
                                                {escola.nom }
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                    
                    </>
                    )}
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default DuplicarModal;
